import { styled, theme } from "@theme/stitches.config"
import { Container, LabelText } from "@components/styles"
// eslint-disable-next-line import/no-unresolved
import { Swiper } from "swiper/react"

export const SponsorsWrapper = styled(Container, {
    overflow: "hidden",
    mt: 126,
    "@mdUp": {
        mt: 68
    }
})

export const Content = styled("div", {})

export const SponsorItems = styled("div", {
    border: `1px solid ${theme.colors.effieGold}`,
    borderRadius: 6,
    width: "100%",
    mt: 68,
    "@mdUp": {
        mt: 46,
        display: "flex",
        flexWrap: "wrap"
    }
})

export const Item = styled("div", {
    padding: "30px 30px 40px",
    "&:not(:first-child)": {
        borderTop: `1px solid ${theme.colors.effieGold}`
    },
    "@mdUp": {
        padding: 50,
        flexBasis: "100%"
    },
    variants: {
        isHalfColumn: {
            true: {
                "@mdUp": {
                    flexBasis: "50%",
                    "&:not(:first-child)": {
                        borderTop: "none"
                    },
                    "&:nth-child(n + 3)": {
                        borderTop: `1px solid ${theme.colors.effieGold}`
                    },
                    "&:nth-child(odd)": {
                        borderRight: `1px solid ${theme.colors.effieGold}`
                    }
                }
            }
        }
    }
})

export const LogosWrapper = styled("div", {
    mt: 20,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "24px 50px",
    "@mdUp": {
        mt: 30,
        columnGap: 64
    }
})

export const ImageWrapper = styled("div", {
    width: 90,
    height: 36,
    display: "flex",
    alignItems: "center",
    "& img, & .gatsby-image-wrapper": {
        display: "block",
    },
    "@mdUp": {
        width: 120,
        height: 50
    }
})

export const AdditionalPartnersWrapper = styled("div", {
    padding: 0,
    mx: -20
})

export const AdditionalPartnerTitle = styled(LabelText, {
    mt: 64,
    textAlign: "center",
    "@mdUp": {
        mt: 98
    }
})

export const StyledSwiper = styled(Swiper, {
    mt: 27,
    "& .swiper-wrapper": {
        transitionTimingFunction: "linear !important"
    },
    "& .swiper-slide": {
        display: "flex",
        alignItems: "center",
        width: "auto",
        height: "auto"
    },
    "@mdUp": {
        mt: 37,
        "&::before, &::after": {
            content: "",
            position: "absolute",
            top: 0,
            bottom: 0,
            width: 77,
            height: "100%",
            zIndex: 10
        },
        "&::before": {
            left: 0,
            background: "linear-gradient(90deg, #fff 44.27%, rgba(255, 255, 255, 0) 100%)"
        },
        "&::after": {
            right: 0,
            background: "linear-gradient(270deg, #fff 44.27%, rgba(255, 255, 255, 0) 100%)"
        }
    }
})

export const AdditionalPartnerImageWrapper = styled("div", {
    height: 50,
    width: 130,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
})
